import { useContext } from 'react';
import { ProjectContext, type ProjectContextValue } from '@/components/projects/ProjectContext';

export function useProject(): Pick<
  ProjectContextValue,
  'activeProject' | 'setActiveProject' | 'loading'
> {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProject must be used within a ProjectProvider');
  }
  return {
    activeProject: context.activeProject,
    setActiveProject: context.setActiveProject,
    loading: context.loading,
  };
}
